import { MenuItemExtended } from "./interface";

export const staticMenu: Array<MenuItemExtended> = [
  {
    to: "/",
    exact: true,
    label: "Overview",
  },
  {
    to: "/work-registration",
    label: "Work Registration",
  },
  {
    to: "/invoices",
    label: "Invoices",
  },
  {
    to: "/accounts",
    label: "Payout Methods",
  },
];
